import { MapLatLng } from '../models/map.latlng';
import { MapMarker } from '../models/map.marker';
import { MapPoint } from '../models/map.point';
import { HMapComponent } from './hmap.component';

declare var H: any;

export class HMapMarker extends MapMarker {
    private hMap: HMapComponent;
    public textMarker: any;
    private inAnimation = false;
    private intervalAnimation: any;
    private timerOffAnimation: any;
    private posOriAnimation: any;
    private static lastMarkerAnimate: any = null;

    constructor(id: number, title: string, label: string, content: string, position: MapLatLng, icon: string,
        zIndex: number, map: any, drag: boolean, visible: boolean, minZoom: number, maxZoom: number, hMap: HMapComponent,
        cluster: any = undefined) {
        super(id, title, label, content, position, icon, zIndex, map, drag, visible, minZoom, maxZoom, cluster);
        // Mapa en el que se inserta el marcador
        this.hMap = hMap;
        // Si no se ha especificado icono pongo uno por defecto
        if (icon == null || icon.length < 1) {
            icon = 'assets/images/redmarker.png';
        }
        // Si se va a añadir a un cluster el marcador se crea más tarde desde el cluster
        if (!cluster) {
            this.createMarker();
        } else {
            this.marker = null;
        }
    }

    createMarker() {
        this.marker = new H.map.Marker(this.position, {
            icon: new H.map.Icon(this.icon, {
                size: new H.math.Size(32, 32),
                anchor: new H.math.Point(16, 16)
            }),
            min: this.minZoom,
            max: this.maxZoom,
            volatility: true,
            visible: this.visible && !this.visibleCluster,
            zIndex: this.zIndex
        });
        this.marker.draggable = this.drag;
        this.setVisible(this.visible);
        this.marker.setData({ id: this.id, title: this.title, content: this.content, marker: this });
        // Si hay etiqueta creo un icono con el texto para mostrarlo encima
        if (this.label && this.label.length > 0) {
            const width = this.label.length * 10; // Porque la fuente es de 10pt
            const iconText = '<svg width="' + width + '" height="32" xmlns="http://www.w3.org/2000/svg">' +
                '<text x="' + width / 2 + '" y="' + this.getTextPos() + '" font-size="10pt" font-family="Verdana" text-anchor="middle">' +
                this.label + '</text></svg>';
            this.textMarker = new H.map.Marker(this.position, {
                icon: new H.map.Icon(iconText, {
                    size: new H.math.Size(width, 32),
                    anchor: new H.math.Point(width / 2, 19)
                }),
                min: this.minZoom,
                max: this.maxZoom,
                volatility: true,
                visible: this.visible,
                zIndex: this.zIndex + 10
            });
            this.textMarker.draggable = this.drag;
            this.textMarker.setData({
                id: this.id, title: this.title, content: this.content, textMarker: this.textMarker, marker: this
            });
            // Asocio el marcador de texto al marcador de imagen
            this.marker.setData({ id: this.id, title: this.title, content: this.content, marker: this, textMarker: this.textMarker });
        }
        this.hMap.markerGroup.addObject(this.marker);
        // Si hay etiqueta añado también el marcador con la etiqueta de texto
        if (this.textMarker) {
            this.hMap.markerGroup.addObject(this.textMarker);
            // Comportamiento por defecto al pasar el cursor sobre un marcador
            this.textMarker.addEventListener('pointerenter', (event: any) => {
                event.target = this.marker;
                this.hMap.onMarkerPointerEnter(event);
            }, false);
            this.textMarker.addEventListener('pointerleave', (event: any) => {
                event.target = this.marker;
                this.hMap.onMarkerPointerLeave();
            }, false);
        }
        // Comportamiento por defecto al pasar el cursor sobre un marcador
        this.marker.addEventListener('pointerenter', (event: any) => {
            this.hMap.onMarkerPointerEnter(event);
        }, false);
        this.marker.addEventListener('pointerleave', (event: any) => {
            this.hMap.onMarkerPointerLeave();
        }, false);
    }

    getTextPos(): number {
        switch (this.icon) {
            case 'assets/images/cluster/m1.png':
                return 30;
            case 'assets/images/cluster/m2.png':
                return 34;
            case 'assets/images/cluster/m3.png':
                return 40;
            case 'assets/images/cluster/m4.png':
                return 45;
            case 'assets/images/cluster/m5.png':
                return 52;
        }
        return 24;
    }

    setTitle(title: string) {
        this.title = title;
        if (this.marker) {
            this.marker.setData({ id: this.id, title: this.title, content: this.content, textMarker: this.textMarker, marker: this });
            if (this.id === this.hMap.selectedToolTipMarker) {
                this.hMap.tooltipMarker.innerHTML = '&nbsp;' + title + '&nbsp;';
            }
        }
    }

    setLabel(label: string) {
        this.label = label;
        if (this.marker && label && label.length > 0) {
            const width = this.label.length * 10; // Porque la fuente es de 10pt
            const iconText = '<svg width="' + width + '" height="32" xmlns="http://www.w3.org/2000/svg">' +
                '<text x="' + width / 2 + '" y="' + this.getTextPos() + '" font-size="10pt" font-family="Verdana" text-anchor="middle">' +
                this.label + '</text></svg>';
            if (this.textMarker) {
                this.textMarker.setIcon(new H.map.Icon(iconText, {
                    size: new H.math.Size(width, 32),
                    anchor: new H.math.Point(width / 2, 19)
                }));
                this.textMarker.setZIndex(this.zIndex + 10);
            } else {
                this.textMarker = new H.map.Marker(this.position, {
                    icon: new H.map.Icon(iconText, {
                        size: new H.math.Size(width, 32),
                        anchor: new H.math.Point(width / 2, 19)
                    }),
                    min: this.minZoom,
                    max: this.maxZoom,
                    volatility: true,
                    visible: this.visible,
                    zIndex: this.zIndex + 10
                });
                this.marker.setData({ id: this.id, title: this.title, content: this.content, textMarker: this.textMarker, marker: this });
                this.hMap.markerGroup.addObject(this.textMarker);
            }
        }
    }

    setContent(content: string) {
        this.content = content;
        if (this.marker) {
            this.marker.setData({ id: this.id, title: this.title, content: this.content, textMarker: this.textMarker, marker: this });
            if (this.id === this.hMap.selectedMarker) {
                this.hMap.infoWindowMarker.setContent(content);
            }
        }
    }

    setPosition(position: MapLatLng) {
        this.position = position;
        if (this.marker) {
            this.marker.setGeometry(position);
            if (this.id === this.hMap.selectedMarker) {
                const pointer = this.map.geoToScreen(this.marker.getGeometry());
                const pos = this.map.screenToGeo(pointer.x, pointer.y - 16);
                this.hMap.infoWindowMarker.setPosition(pos);
            }
            if (this.textMarker) {
                this.textMarker.setGeometry(position);
            }
        }
        if (this.clusterV2) {
            this.clusterV2.refreshMarker(this);
        }
    }

    setPositionNotRefreshCluster(position: MapLatLng) {
        this.position = position;
        if (this.marker) {
            this.marker.setGeometry(position);
            if (this.id === this.hMap.selectedMarker) {
                const pointer = this.map.geoToScreen(this.marker.getGeometry());
                const pos = this.map.screenToGeo(pointer.x, pointer.y - 16);
                this.hMap.infoWindowMarker.setPosition(pos);
            }
            if (this.textMarker) {
                this.textMarker.setGeometry(position);
            }
        }
    }

    setIcon(icon: string) {
        this.icon = icon;
        // Si no se ha especificado icono pongo uno por defecto
        if (icon == null || icon.length < 1) {
            icon = 'assets/images/redmarker.png';
        }
        if (this.marker) {
            this.marker.setIcon(new H.map.Icon(icon, {
                size: new H.math.Size(32, 32),
                anchor: new H.math.Point(16, 16)
            }));
        }
        if (this.textMarker) {
            const width = this.label.length * 10; // Porque la fuente es de 10pt
            const iconText = '<svg width="' + width + '" height="32" xmlns="http://www.w3.org/2000/svg">' +
                '<text x="' + width / 2 + '" y="' + this.getTextPos() + '" font-size="10pt" font-family="Verdana" text-anchor="middle">' +
                this.label + '</text></svg>';
            this.textMarker.setIcon(new H.map.Icon(iconText, {
                size: new H.math.Size(width, 32),
                anchor: new H.math.Point(width / 2, 19)
            }));
            this.textMarker.setZIndex(this.zIndex + 10);
        }
    }

    setIconEx(icon: string, sizeX: number, sizeY: number, origin: MapPoint, anchor: MapPoint) {
        this.icon = icon;
        if (this.marker) {
            this.marker.setIcon(new H.map.Icon(icon, {
                size: new H.math.Size(sizeX, sizeY),
                anchor: new H.math.Point(sizeX / 2, sizeY)
            }));
        }
        if (this.textMarker) {
            const width = this.label.length * 10; // Porque la fuente es de 10pt
            const iconText = '<svg width="' + width + '" height="' + sizeY + '" xmlns="http://www.w3.org/2000/svg">' +
                '<text x="' + width / 2 + '" y="' + this.getTextPos() + '" font-size="10pt" font-family="Verdana" text-anchor="middle">' +
                this.label + '</text></svg>';
            this.textMarker.setIcon(new H.map.Icon(iconText, {
                size: new H.math.Size(width, sizeY),
                anchor: new H.math.Point(width / 2, sizeY)
            }));
            this.textMarker.setZIndex(this.zIndex + 10);
        }
    }

    setAnchor(icon: string, sizeX: number, sizeY: number, anchorX: number, anchorY: number) {
        this.marker.setIcon(new H.map.Icon(icon, {
            size: new H.math.Size(sizeX, sizeY),
            anchor: new H.math.Point(anchorX, anchorY)
        }));
        if (this.textMarker) {
            const width = this.label.length * 10; // Porque la fuente es de 10pt
            const iconText = '<svg width="' + width + '" height="' + sizeY + '" xmlns="http://www.w3.org/2000/svg">' +
                '<text x="' + width / 2 + '" y="' + this.getTextPos() + '" font-size="10pt" font-family="Verdana" text-anchor="middle">' +
                this.label + '</text></svg>';
            this.textMarker.setIcon(new H.map.Icon(iconText, {
                size: new H.math.Size(width, sizeY),
                anchor: new H.math.Point(width / 2, 40)
            }));
        }
    }

    setZIndex(zIndex: number) {
        this.zIndex = zIndex;
        if (this.marker) {
            this.marker.setZIndex(zIndex);
            if (this.textMarker) {
                this.textMarker.setZIndex(zIndex + 10);
            }
        }
    }

    setVisible(visible: boolean) {
        this.visible = visible;
        if (this.clusterV2) {
            if (this.visibleCluster && visible) {
                if (!this.marker) {
                    this.createMarker();
                }
                this.marker.setVisibility(true);
                if (this.textMarker) {
                    this.textMarker.setVisibility(true);
                    this.textMarker.setZIndex(this.zIndex + 10);
                }
            } else {
                if (this.marker) {
                    this.marker.setVisibility(false);
                }
                if (this.textMarker) {
                    this.textMarker.setVisibility(false);
                }
            }
        } else {
            this.marker.setVisibility(visible);
            if (this.textMarker) {
                this.textMarker.setVisibility(visible);
                if (visible) {
                    this.textMarker.setZIndex(this.zIndex + 10);
                }
            }
        }
    }

    setVisibleCluster(visible: boolean) {
        if (this.clusterV2 && this.visibleCluster !== visible) {
            this.visibleCluster = visible;
            if (visible) {
                this.setVisible(this.visible);
                if (visible && this.textMarker) {
                    this.textMarker.setZIndex(this.zIndex + 10);
                }
            } else {
                if (this.marker) {
                    this.marker.setVisibility(false);
                    if (this.textMarker) {
                        this.textMarker.setVisibility(false);
                    }
                }
            }
        }
    }

    setVisibleFromCluster(visible: boolean) {
        this.visible = visible;
        if (this.clusterV2) {
            if (this.visibleCluster && visible) {
                if (!this.marker) {
                    this.createMarker();
                }
                this.marker.setVisibility(true);
                if (this.textMarker) {
                    this.textMarker.setVisibility(true);
                    this.textMarker.setZIndex(this.zIndex + 10);
                }
            } else {
                if (this.marker) {
                    this.marker.setVisibility(false);
                    if (this.textMarker) {
                        this.textMarker.setVisibility(false);
                    }
                }
            }
        } else {
            this.marker.setVisibility(visible);
            if (this.textMarker) {
                this.textMarker.setVisibility(visible);
                if (visible) {
                    this.textMarker.setZIndex(this.zIndex + 10);
                }
            }
        }
    }

    hide() {
        if (this.marker) {
            this.textMarker.setVisibility(false);
        }
    }

    animate(milisec: number) {
        if (HMapMarker.lastMarkerAnimate && HMapMarker.lastMarkerAnimate !== this) {
            clearTimeout(HMapMarker.lastMarkerAnimate.timerOffAnimation);
            clearInterval(HMapMarker.lastMarkerAnimate.intervalAnimation);
            HMapMarker.lastMarkerAnimate.setPosition(HMapMarker.lastMarkerAnimate.posOriAnimation);
            HMapMarker.lastMarkerAnimate.inAnimation = false;
        }
        if (!this.inAnimation) {
            HMapMarker.lastMarkerAnimate = this;
            this.inAnimation = true;
            if (!this.marker) {
                this.createMarker();
            }
            this.posOriAnimation = this.position;
            const p1 = this.map.geoToScreen(this.position);
            let i = 0, inc = -1;
            this.intervalAnimation = setInterval(() => {
                p1.y += inc;
                this.setPosition(this.map.screenToGeo(p1.x, p1.y));
                i++;
                if (i >= 50) {
                    inc = -inc;
                    i = 0;
                }
            }, 10);
            this.timerOffAnimation = setTimeout(() => {
                clearInterval(this.intervalAnimation);
                this.setPosition(this.posOriAnimation);
                this.inAnimation = false;
            }, milisec);
        }
    }

    setDraggable(drag: boolean) {
        this.drag = drag;
        if (this.marker) {
            this.marker.draggable = drag;
        }
    }

    // Calcula la distancia en metros entre dos puntos
    dist(point1: MapLatLng, point2: MapLatLng): number {
        const R = 6371; // km
        const dLat = this.toRad(point2.lat - point1.lat);
        const dLon = this.toRad(point2.lng - point1.lng);
        const lat1 = this.toRad(point1.lat);
        const lat2 = this.toRad(point2.lat);
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const d = R * c;
        return Math.abs(d * 1000.0); // Distancia en metros
    }

    // Grados a radianes
    toRad(value: number): number {
        return value * Math.PI / 180;
    }
}
